import { useState } from "react";
import { Button } from "expano-components";
import { Dashboard } from "components";

import AddBrand from "./components/AddBrand";

const Brands = ({ producer_id, refetch, data }) => {
  const [is_open_brand_modal, setOpenBrandModal] = useState(false);

  return (
    <Dashboard
      header={{
        icon: "info",
        title: "Marki",
      }}
      footer={
        <Button
          type="add"
          text="Dodaj markę"
          onClick={() => setOpenBrandModal(true)}
        />
      }
    >
      {is_open_brand_modal && (
        <AddBrand
          producer_id={producer_id}
          refetch={refetch}
          handleClose={() => setOpenBrandModal(false)}
        />
      )}
      {data?.length > 0 && (
        <table className="table">
          <tbody className="table__body table-body">
            {data.map(({ id, name }) => (
              <tr key={id}>
                <td>
                  <a
                    className="text-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`/brands/${id}`}
                  >
                    {name}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Dashboard>
  );
};

export default Brands;
